import React from 'react'
import styles from './Menu.module.scss'

export type MenuPosition = 'header' | 'footer' | 'extra'

export const MenuContext = React.createContext<{ position: MenuPosition }>({ position: 'header' })

type MenuProps = React.PropsWithChildren<{
  place?: MenuPosition,
}>

export const Menu: React.FC<MenuProps> = (props) => {
  const { place = 'header', children } = props
  return (
    <MenuContext.Provider value={{ position: place }}>
      <div className={styles.container} data-position={place}>
        <nav className={styles.content}>
          <hr className={styles.border} />
          <menu className={styles.menu}>
            {children}
          </menu>
          <hr className={styles.border} />
        </nav>
      </div>
    </MenuContext.Provider>
  )
}
